<ion-content>
  <div id="infos-container">
    <h2>Valorisez votre savoir-être professionnel,<br> transformez vos compétences en atouts reconnus.</h2>
  
    <p>Dans un monde professionnel en constante évolution, les soft skills sont devenues aussi essentielles que les compétences techniques. IACDP est une plateforme innovante qui permet de les identifier, les développer et les évaluer pour les certifier et les valoriser.</p>
  
    <ion-button id="start-btn" shape="round" (click)="login()">Démarrer</ion-button>
  </div>
</ion-content>